import { FormikProps } from "formik";
import { useContext, useMemo } from "react";
import {
  ItemViewModel,
  SubmitCreation,
  SubmitCreationRightsHolder,
} from "../../../../../generated/data-contracts";
import {
  AvisEditableList,
  editableTableActionWidth,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../shared/components/editableList";
import { AvisSection } from "../../../../shared/components/form";
import {
  AvisDropdown,
  AvisInputText,
} from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationNewRightHoldersProps {
  bag: FormikProps<SubmitCreation>;
  bagField: keyof SubmitCreation;
  disabled: boolean;
  roles: ItemViewModel[] | undefined;
  textKey: string;
}
export function CreationNewRightHolders(
  props: Readonly<ICreationNewRightHoldersProps>,
) {
  const { bag, bagField, disabled, roles, textKey } = props;
  const { res } = useContext(AvisContext);

  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<SubmitCreationRightsHolder>
  >[] = useMemo(
    () => [
      {
        name: "additionalInformation",
        title: res("authors_Creation_label_Author"),
        required: true,
        width: 280 + (disabled ? editableTableActionWidth : 0),
        renderField: (field, prefix, i, val, onChange) => {
          return (
            <AvisInputText
              name={`${prefix}.${i}.${field.name}`}
              value={val[field.name]?.toString()}
              maxLength={100}
              onChange={onChange}
              disabled={disabled || val.isCurrentRightsHolder}
              required={field.required}
              hideClear
            />
          );
        },
      },
      {
        name: "creationRoleId",
        title: res("authors_Creation_label_CreativeProfiles"),
        required: true,
        width: 390,
        transformViewValue: (fieldValue) => {
          return (
            roles?.filter((item) => item.id == fieldValue)?.[0]?.name ?? ""
          );
        },
        renderField: (field, prefix, i, val, onChange) => {
          return (
            <AvisDropdown<ItemViewModel>
              name={`${prefix}.${i}.${field.name}`}
              value={val[field.name]}
              onChange={onChange}
              options={roles}
              optionValue="id"
              optionLabel="name"
              disabled={disabled}
              required={field.required}
              hideClear
            />
          );
        },
      },
    ],
    [disabled, res, roles],
  );

  return (
    <AvisSection
      title={res("authors_Creation_Section_RHs_Title")}
      textToDisplayKey={textKey}
    >
      <AvisEditableList<SubmitCreation, IRowState<SubmitCreationRightsHolder>>
        bag={bag}
        bagField={bagField}
        isDeletable={(fieldValue) => fieldValue.isCurrentRightsHolder !== true}
        initValue={{
          additionalInformation: "",
          creationRoleId: 0,
          rowState: "Add",
        }}
        forceUpdateKey={roles}
        fields={fieldCollection}
        disabled={disabled}
      />
    </AvisSection>
  );
}
